import { render, staticRenderFns } from "./AccountRequestReview.vue?vue&type=template&id=2e3b3828&"
import script from "./AccountRequestReview.vue?vue&type=script&lang=js&"
export * from "./AccountRequestReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports